import React, { useState, useEffect } from 'react'
import { Grid } from "@mui/material"
import styled from '@emotion/styled'

import AutoCompleteSolo from '../../../utils/utilities/AutoCompleteSolo';

import { useFormikContext } from 'formik';

// form context
import useRequestItems from '../../../hooks/useRequestItems';

import EditInventoryItem from '../../InventoryItem/EditInventory';

import InventoryItem from '../../../utils/utilities/WigComponents/InventoryItem';

import ShipmentItems from './ShipmentItems';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import { BasicFlex } from '../../../utils/Common';

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 2.5rem; */
  margin-top: 2.5rem;
`;

const RequestItems = () => {
  const { values } = useFormikContext() || {};
  const { formValues = {}, setFormValues, editItem, removeItem } = useRequestItems();

  const disabled = !values?.vendor_id

  const updates = ["inventory_item_id", "sku", "color", "length", "material", "cap_size", "hairstyle", "total_price", "length_unit", "brand_name", "line"];

  const update = {
    updates,
    updateFunc: setFormValues,
    arrToUpdate: "items"
  }

  const removeItemWithWigs = (sku) => {
    setFormValues(oldObj => {
      // Create a new array with the item filtered out
      const filteredArray = oldObj.items.filter(item => item.sku !== sku);
      const filteredWigs = oldObj.wigs.filter(wig => wig.sku !== sku);
      // Return a new object with the updated array
      return {
        ...oldObj,
        items: filteredArray,
        wigs: filteredWigs
      };
    });
  }

  useEffect(() => {
    if (values?.wigs?.length) {
      let uniqueItems = values.wigs.reduce((acc, curr) => {
        acc[curr.sku] = {
          inventory_item_id: curr.inventory_item_id,
          sku: curr.sku,
          brand_name: curr.brand_name
        };
        return acc;
      }, {});

      setFormValues(oldObj => ({
        ...oldObj,
        items: Object.values(uniqueItems),
        wigs: values.wigs
      }));
    }
  }, [values?.wigs])

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <AutoCompleteSolo placeholder="Search Inventory Sku" fieldName="sku" useForm={true} FormComponent={<EditInventoryItem dialog={true}/>} update={update} disabled={disabled} conditionStr={`&vendor_id[$eq]=${values?.vendor_id}`} server={true} />
      </Grid>

      <Grid size={{ xs: 12, md: 6}}>
        <BasicFlex justify="flex-end">
          <SimpleChip label={`Total Items: ${formValues.wigs.length}`} />
        </BasicFlex>
      </Grid>
      

      <Grid size={{ xs: 12 }}>
        <ItemList>
         {formValues.items?.map((item, index) => {
          let count = formValues.wigs?.filter(wig => wig.sku === item.sku)?.length
          item.new_fulfilled_qty = item.fulfilled_qty + count;
          return (
          <React.Fragment key={item.sku}>
            <InventoryItem item={item} arr="items" removeItem={removeItemWithWigs} editItem={editItem} displayOnly />
            <ShipmentItems inventoryItem={item} />
          </React.Fragment>
          )})}
        </ItemList>
      </Grid>
    </Grid>
  )
}

export default RequestItems;